import React from 'react';

const TrainingOfferings = () => {
  const trainings = [
    {
      title: "SIS Lifecycle Management Workshops",
      duration: "3 days",
      level: "Intermediate to Advanced",
      description: "Comprehensive training on managing safety instrumented systems throughout their lifecycle",
      topics: [
        "SIS design and engineering",
        "Installation and commissioning",
        "Operation and maintenance",
        "Modification management"
      ],
      icon: "fas fa-cogs"
    },
    {
      title: "Functional Safety Audit Courses",
      duration: "2 days",
      level: "Advanced",
      description: "Learn to conduct thorough functional safety audits and assessments",
      topics: [
        "Audit planning and preparation",
        "Documentation review techniques",
        "Field verification methods",
        "Report writing and recommendations"
      ],
      icon: "fas fa-clipboard-check"
    },
    {
      title: "SIL & LOPA Practical Trainings",
      duration: "4 days",
      level: "All Levels",
      description: "Hands-on training in Safety Integrity Level determination and Layer of Protection Analysis",
      topics: [
        "Risk assessment fundamentals",
        "SIL calculation methods",
        "LOPA methodology",
        "Real-world case studies"
      ],
      icon: "fas fa-calculator"
    }
  ];

  return (
    <section className="min-h-screen flex items-center py-20 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto w-full">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Training Offerings</h2>
          <p className="text-xl text-gray-600">Professional development for safety excellence</p>
        </div>
        
        <div className="space-y-12">
          {trainings.map((training, index) => (
            <div key={index} className="bg-gray-50 rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
              <div className="md:flex">
                <div className="md:w-1/3 bg-gradient-to-br from-blue-600 to-blue-800 p-8 flex items-center justify-center">
                  <i className={`${training.icon} text-6xl text-white`}></i>
                </div>
                <div className="md:w-2/3 p-8">
                  <h3 className="text-2xl font-bold text-gray-900 mb-2">{training.title}</h3>
                  <div className="flex flex-wrap gap-4 mb-4">
                    <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-blue-100 text-blue-800">
                      <i className="fas fa-clock mr-2"></i>{training.duration}
                    </span>
                    <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-green-100 text-green-800">
                      <i className="fas fa-signal mr-2"></i>{training.level}
                    </span>
                  </div>
                  <p className="text-gray-600 mb-4">{training.description}</p>
                  <div className="space-y-2">
                    <h4 className="font-semibold text-gray-900">Topics Covered:</h4>
                    {training.topics.map((topic, idx) => (
                      <div key={idx} className="flex items-center text-gray-700">
                        <i className="fas fa-check text-green-500 mr-2"></i>
                        <span>{topic}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        <div className="mt-12 relative">
          <img
            src="/assets/asset-8.jpg"
            alt="Engineers in classroom"
            className="w-full rounded-lg shadow-xl"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent rounded-lg"></div>
        </div>
      </div>
    </section>
  );
};

export default TrainingOfferings;
